// extracted by mini-css-extract-plugin
export default {"stack":"EquationSide_stack__3uu+d","skeleton":"EquationSide_skeleton__IuvJE"};